export default "__VITE_ASSET__DvUQc2c0__"